import AssetTemplateReadDto, { Groups, Endpoints, Gateways } from '../../../Models/Assets/AssetTemplateReadDto';

export const getEndpointUniqueKey = (endpoint: any) => {
  const groupId = endpoint.groupId || '';
  const endpointId = (endpoint.id ?? '').toString();
  const pointId = endpoint.pointId != null ? String(endpoint.pointId) : '';
  const serialNumber = endpoint.endpointDeviceSerialNumber || '';
  const name = endpoint.name || '';
  const combined = [groupId, endpointId, pointId, serialNumber].filter(Boolean).join('-');

  return combined || `ep-${groupId}-${name}`;
};

export const buildMappedEndpointsByPump = (endpoints: Endpoints[]) => {
  const map: Record<string, string[]> = {};

  endpoints.forEach((endpoint) => {
    if (!endpoint.greasePumpId) {
      return;
    }

    if (!map[endpoint.greasePumpId]) {
      map[endpoint.greasePumpId] = [];
    }

    if (endpoint.endpointDeviceSerialNumber) {
      map[endpoint.greasePumpId].push(endpoint.endpointDeviceSerialNumber);
    }
  });

  return map;
};

// Build updated template for grease pump component
export const buildGreasePumpTemplate = (
  templateData: any,
  groups: Groups[],
  greasePumps: Groups[],
  endpoints: Endpoints[],
  gateways: Gateways[],
  greasePumpConnectivity: 'enabled' | 'disabled'
): AssetTemplateReadDto => {
  return {
    id: templateData.id,
    name: templateData.name,
    description: templateData.description,
    imageId: templateData.imageId,
    isGreasePumpConnectivityEnabled: greasePumpConnectivity === 'enabled',
    groups: groups.map(group => ({
      ...group,
      parentId: group.parentId || '',
      imageId: group.imageId || '',
      status: (group as any).status ?? 'Active',
      attachmentImageIds: group.attachmentImageIds || []
    })),
    endpoints: endpoints.map(endpoint => ({
      ...endpoint,
      endpointDeviceId: endpoint.endpointDeviceId || '',
      endpointDeviceSerialNumber: endpoint.endpointDeviceSerialNumber || '',
      requirementId: endpoint.requirementId || '',
      requirementName: endpoint.requirementName || '',
      xPos: endpoint.xPos || 0,
      yPos: endpoint.yPos || 0,
      status: (endpoint as any).status ?? 'Active'
    })),
    greasePumps: greasePumps.map((pump: any) => ({
      ...pump,
      deviceId: pump.deviceId || '',
      serialNo: pump.serialNo || '',
      channelNo: pump.channelNo ?? pump.channel ?? 0,
      timingOffsetSeconds: pump.timingOffsetSeconds ?? 0
    })),
    gateways: gateways.map(gw => ({ ...gw, status: gw.status ?? 'Active' }))
  };
};

// Get columns display position for grease pump component
export const getGreasePumpColumnsDisplayPosition = (isSingleColumn: boolean) => {
  return isSingleColumn
    ? [
        { col: 1, colSpan: 1, rowSpan: 3 },
        { col: 1, colSpan: 1, rowSpan: 4 },
      ]
    : [
        { col: 1, colSpan: 2, rowSpan: 4 },
        { col: 3, colSpan: 3, rowSpan: 4 },
      ];
};

